import React from 'react';
export function UrgencyBanner() {
  return <div className="w-full bg-gradient-to-r from-[#5C1A1B] via-[#7A2325] to-[#5C1A1B] py-3 px-4 shadow-md" data-id="element-321">
      <p className="text-center text-white font-inter font-semibold text-sm sm:text-base tracking-wide" data-id="element-322">
        ⚡️ ALTA DEMANDA: Ultimas 4 limpiezas del año!
      </p>
    </div>;
}